import {
	SET_SCHED_TASK_EXPORTS_ENTITY,
	SET_SCHED_TASK_EXPORTS_OUTPUTS,
	SAVE_SCHED_TASK_EXPORT,
	SET_SCHED_TASK_CUSTOM_ERROR
} from './scheduled-tasks-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';
import { cloneDeep } from 'lodash';

const initialState = {
	customReportSchedules: {},
	scheduledTasksExportsOutputs: {},
	scheduledTaskExportDetails: {},
	responseError: null,
	customErrorStatusCode: null,
	customErrorErrorCode: null,
	customErrorMessage: null
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'scheduledTasks',
	state: cloneDeep(initialState),
	namespaced: true,
	mutations: {
		[SET_SCHED_TASK_EXPORTS_ENTITY](state, customReportSchedules) {
			state.customReportSchedules = customReportSchedules;
		},
		[SET_SCHED_TASK_EXPORTS_OUTPUTS](state, scheduledTasksExportsOutputs) {
			state.scheduledTasksExportsOutputs = scheduledTasksExportsOutputs;
		},
		[SAVE_SCHED_TASK_EXPORT](state, scheduledTaskExportDetails) {
			state.scheduledTaskExportDetails = scheduledTaskExportDetails;
		},
		[SET_SCHED_TASK_CUSTOM_ERROR](state, error) {
			state.responseError = error?.response;
		}
	},
	actions: {
		async getCustomReportSchedulesAction(
			{ commit },
			{ companyId, entityId, entityTypeId, query }
		) {
			commit(SET_SCHED_TASK_CUSTOM_ERROR, undefined);

			const path = buildRoute(
				'/scheduledtasks/company/{companyId}/scheduledtasks/exports/{entityTypeId}/{entityId}',
				{
					companyId,
					entityId,
					entityTypeId,
					query
				}
			);
			const scheduledTaskExportsDB = await api.get(path);
			commit(SET_SCHED_TASK_EXPORTS_ENTITY, scheduledTaskExportsDB);
		},
		async createScheduleTaskExportAction(
			{ commit, getters },
			{ companyId, payload, errorHandler }
		) {
			commit(SET_SCHED_TASK_CUSTOM_ERROR, undefined);

			const path = buildRoute(
				'/scheduledtasks/company/{companyId}/scheduledtasks/export/{scheduledTaskId}',
				{
					companyId,
					scheduledTaskId: payload?.id || 0
				}
			);

			const result = await api.post(path, payload, function(
				error,
				globalErrorHandler
			) {
				commit(SET_SCHED_TASK_CUSTOM_ERROR, error);
				commit(SAVE_SCHED_TASK_EXPORT, {});

				if (errorHandler) {
					errorHandler(error, globalErrorHandler);
					return;
				}

				globalErrorHandler(error);
			});

			if (!getters.hasCustomError) {
				commit(SAVE_SCHED_TASK_EXPORT, result);
			}
		},
		async getScheduledTaskExportsRunsAction(
			{ commit },
			{ companyId, query }
		) {
			commit(SET_SCHED_TASK_CUSTOM_ERROR, undefined);

			const path = buildRoute(
				'/scheduledtasks/company/{companyId}/scheduledtasks/exports/runs',
				{
					companyId,
					query
				}
			);
			const results = await api.get(path);
			commit(SET_SCHED_TASK_EXPORTS_OUTPUTS, results);
		},
		async deleteScheduledTaskExportsAction(
			{ commit, getters },
			{ companyId, scheduledTaskId, errorHandler }
		) {
			commit(SET_SCHED_TASK_CUSTOM_ERROR, undefined);

			const path = buildRoute(
				'/scheduledtasks/company/{companyId}/scheduledtasks/export/{scheduledTaskId}',
				{
					companyId,
					scheduledTaskId
				}
			);
			const results = await api.delete(path, {}, function(
				error,
				globalErrorHandler
			) {
				commit(SET_SCHED_TASK_CUSTOM_ERROR, error);

				if (errorHandler) {
					errorHandler(error, globalErrorHandler);
					return;
				}

				globalErrorHandler(error);
			});

			if (!getters.hasCustomError) {
				commit(SET_SCHED_TASK_EXPORTS_ENTITY, results);
			}
		},
		clearCustomErrorAction({ commit }) {
			commit(SET_SCHED_TASK_CUSTOM_ERROR, undefined);
		}
	},
	getters: {
		customReportSchedules: state => state.customReportSchedules,
		scheduledTasksExportsOutputs: state => state.scheduledTasksExportsOutputs,
		scheduledTaskExportDetails: state => state.scheduledTaskExportDetails,
		responseError: state => state.responseError,
		hasCustomError: state => !!state.responseError,
		customErrorStatusCode: state => state.responseError?.status,
		customErrorErrorCode: state =>
			state.responseError?.data?.errorCode ?? 'Not provided',
		customErrorMessage: state =>
			state.responseError?.data?.message ?? 'Unknown error'
	}
};
